export default () => {
  for (const card of document.querySelectorAll(".cards__list")) {
    const wrapper = card.querySelector(".card__wrapper");
    const body = card.querySelector(".card__body");
    let deviceSize = window.innerWidth;

    if (wrapper && body && deviceSize) {

      function moveBodyUp() {
        const wrapper = card.querySelector(".card__wrapper");
        const h4 = body.querySelector("h4");
        const calcHeight = wrapper.offsetHeight - 66 // height of the title element
        body.style.height = calcHeight + 'px';

        if (h4) {
          if (deviceSize < 480) {
            h4.style.fontSize = "20px";
            h4.style.lineHeight = "20px";
            body.style.padding = "1rem";
          } else {
            body.style.padding = "1.5rem";
            h4.style.fontSize = "32px";
            h4.style.lineHeight = "40px";
          }
        } else {
          if (deviceSize < 480) {
            body.style.fontSize = "20px";
            body.style.lineHeight = "20px";
            body.style.padding = "1rem";
          } else {
            body.style.padding = "1.5rem";
            body.style.fontSize = "32px";
            body.style.lineHeight = "40px";
          }
        }

        body.style.transition = "height 1s ease-in-out, font-size 0.1s ease-in-out";
      };

      function moveBodyDown() {
        body.style.height = "0px";
        body.style.padding = "0";
        body.style.fontSize = "0";
        body.style.transition = "font-size 0.1s ease-in-out, padding 1s ease-in-out, height 1s ease-in-out";
      }

      // Expand on hover
      wrapper.addEventListener("mouseenter", () => {
        moveBodyUp();
      });

      // Collapse on mouse leave
      wrapper.addEventListener("mouseleave", () => {
        moveBodyDown();
      });

      // Handle touch events for mobile
      wrapper.addEventListener("touchstart", () => {
        moveBodyUp();
      });

      wrapper.addEventListener("touchend", () => {
        moveBodyDown();
      });
    }

    // Update deviceSize on window resize
    window.addEventListener("resize", () => {
      deviceSize = window.innerWidth;
    });
  }
};
